export const registerServiceWorker = async (firebaseConfig: any) => {
  const urlFirebaseConfig = new URLSearchParams(firebaseConfig).toString();
  const serviceWorkerRegistration = await navigator.serviceWorker.register(
    `/firebase-messaging-sw.js?${urlFirebaseConfig}`,
  );
  return serviceWorkerRegistration;
};
